/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GranularityLevelEnum } from './GranularityLevelEnum';
import {
    GranularityLevelEnumFromJSON,
    GranularityLevelEnumFromJSONTyped,
    GranularityLevelEnumToJSON,
    GranularityLevelEnumToJSONTyped,
} from './GranularityLevelEnum';

/**
 * Command to retrieve activity feed history with a specific granularity level
 * @export
 * @interface GetHistoryByGranularityCommand
 */
export interface GetHistoryByGranularityCommand {
    /**
     * 
     * @type {GranularityLevelEnum}
     * @memberof GetHistoryByGranularityCommand
     */
    granularity?: GranularityLevelEnum;
    /**
     * Page number (1-based)
     * @type {number}
     * @memberof GetHistoryByGranularityCommand
     */
    pageNumber?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof GetHistoryByGranularityCommand
     */
    pageSize?: number;
}



/**
 * Check if a given object implements the GetHistoryByGranularityCommand interface.
 */
export function instanceOfGetHistoryByGranularityCommand(value: object): value is GetHistoryByGranularityCommand {
    return true;
}

export function GetHistoryByGranularityCommandFromJSON(json: any): GetHistoryByGranularityCommand {
    return GetHistoryByGranularityCommandFromJSONTyped(json, false);
}

export function GetHistoryByGranularityCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetHistoryByGranularityCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'granularity': json['granularity'] == null ? undefined : GranularityLevelEnumFromJSON(json['granularity']),
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function GetHistoryByGranularityCommandToJSON(json: any): GetHistoryByGranularityCommand {
    return GetHistoryByGranularityCommandToJSONTyped(json, false);
}

export function GetHistoryByGranularityCommandToJSONTyped(value?: GetHistoryByGranularityCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'granularity': GranularityLevelEnumToJSON(value['granularity']),
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
    };
}

